module.exports = "<div class=\"page-inner\">\n\t<p>\n\t  question works!\n\t</p>\n</div>\n\n\n"


//////////////////
// WEBPACK FOOTER
// /home/kalinin/angular2/PRACTICE/feedback/src/app/question/question.component.html
// module id = ../../../../../src/app/question/question.component.html
// module chunks = 1